<template>
	<div>
		<div class="logo-area py-9">
			<v-img
				height="58"
				contain
				:src="
					`https://${keyword}.libnet.info/images/${keyword}/card-logo.png`
				"
			></v-img>
		</div>
		<div v-sticky class="search-header">
			<div class="search-form-holder">
				<div class="basket-area py-8 px-2">
					<span
						class="search-header-title display-1 font-weight-light"
						>{{ $t('reserve.title') }}</span
					>
				</div>
			</div>
		</div>
		<v-container class="room-details mx-auto">
			<v-row>
				<v-col>
					<router-link to="/reserve">back</router-link>
				</v-col>
			</v-row>
			<v-row>
				<v-col>
					<v-carousel
						class="room-image"
						max-width="520px"
						height="400px"
						v-if="room.images && room.images.length > 0"
					>
						<v-carousel-item
							v-for="(item, i) in room.images"
							:key="i"
							:src="
								`https://${keyword}.libnet.info/images/roombooking/${keyword}/${item}`
							"
							reverse-transition="fade-transition"
							transition="fade-transition"
						></v-carousel-item>
					</v-carousel>
					<v-img
						class="room-image"
						v-else-if="room.image"
						:src="
							`https://${keyword}.libnet.info/images/roombooking/${keyword}/${room.image}`
						"
					></v-img>
					<v-card flat>
						<v-list-item three-line>
							<v-list-item-content>
								<v-list-item-subtitle
									v-html="
										getLocationForId(room.location_id).name
									"
								></v-list-item-subtitle>
								<v-list-item-title
									v-html="room.name"
									class="headline mb-1"
								></v-list-item-title>
							</v-list-item-content>

							<v-list-item-avatar tile width="60">
								<v-icon>people_outline</v-icon
								><span class="pl-1">{{ roomCapacity }}</span>
							</v-list-item-avatar>
						</v-list-item>
					</v-card>
					<v-card flat>
						<v-chip color="grey-lighten-5" text-color="black">
							<v-avatar class="mr-1">
								<v-icon>photo_size_select_small</v-icon>
							</v-avatar>
							{{ $t('reserve.roomSize') }}
						</v-chip>
						<v-divider></v-divider>
					</v-card>
				</v-col>
				<v-col class="room-details-sidebar">
					<v-card
						class="mb-8 pa-6 elevation-8"
						v-if="
							clientSettings.rooms_group_billing_enabled &&
								userClasses.length > 1
						"
					>
						<v-select
							outlined
							dense
							:hide-details="true"
							:items="userClasses"
							:label="$t('reserve.bookingTypeLabel')"
							item-text="name"
							item-value="id"
							v-model="userClassId"
							prepend-inner-icon="perm_identity"
							@change="setUserClass($event)"
						>
							<v-icon
								slot="prepend-inner"
								class="d-none d-sm-none d-md-flex"
								>perm_identity</v-icon
							>
						</v-select>
					</v-card>
					<v-card class="mb-8 pa-6 elevation-8">
						<v-row>
							<v-col class="pa-0">
								<v-menu
									v-model="showDate"
									:close-on-content-click="false"
									transition="scale-transition"
									offset-y
									max-width="290px"
									min-width="290px"
								>
									<template v-slot:activator="{ on }">
										<v-text-field
											outlined
											dense
											:hide-details="true"
											v-model="formattedDate"
											append-icon="arrow_drop_down"
											:label="$t('reserve.date')"
											readonly
											v-on="on"
										>
											<v-icon
												slot="prepend-inner"
												class="d-none d-sm-none d-md-flex"
												>event</v-icon
											></v-text-field
										>
									</template>
									<v-date-picker
										v-model="selectedDate"
										no-title
										@input="showDate = false"
									>
									</v-date-picker> </v-menu
							></v-col>
							<v-col class="px-1 py-0" cols="auto">
								<v-btn
									class="px-1"
									outlined
									height="40"
									min-width="50"
									@click="changeDay(-1)"
									color="grey"
									><v-icon>chevron_left</v-icon></v-btn
								>
							</v-col>
							<v-col class="px-1 py-0" cols="auto">
								<v-btn
									class="px-1"
									outlined
									height="40"
									min-width="50"
									@click="changeDay(1)"
									color="grey"
									><v-icon>chevron_right</v-icon></v-btn
								>
							</v-col>
						</v-row>
					</v-card>
				</v-col>
			</v-row>
		</v-container>
	</div>
</template>

<script>
import moment from 'moment';
export default {
	data() {
		return {
			showDate: false,
			room: {},
			loading: false
		};
	},
	created() {
		this.keyword = window.config.keyword;
	},
	mounted() {
		const details = this.$store.getters.getRoomDetailsForId(this.id);
		if (details) {
			this.room = details;
		} else {
			this.updateDetails();
		}
	},
	methods: {
		setUserClass(event) {
			this.$store
				.dispatch('setUserClass', event)
				.then(() => this.updateDetails());
		},
		changeDay(amount) {
			this.selectedDate = moment(this.selectedDate)
				.add(amount, 'days')
				.format('YYYY-MM-DD');
		},
		updateDetails() {
			this.loading = true;
			this.$store
				.dispatch('fetchRoomDetailsById', {
					room: this.id,
					classId: this.userClassId,
					date: this.selectedDate
				})
				.then(() => {
					this.room = this.$store.getters.getRoomDetailsForId(
						this.id
					);
					this.loading = false;
				});
		},
		getLocationForId(id) {
			return this.$store.getters.userClassGetLocationForId(id) || {};
		}
	},
	computed: {
		id() {
			return this.$route.params.id || null;
		},
		userClasses() {
			return this.$store.state.userClasses.filter(
				c => parseInt(c.type) > 0
			);
		},
		clientSettings() {
			return this.$store.state.clientSettings;
		},
		formattedDate() {
			const format = this.$vuetify.breakpoint.smAndUp
				? 'D MMM YYYY'
				: 'D MMM';
			return this.selectedDate
				? moment(this.selectedDate).format(format)
				: '';
		},
		roomCapacity() {
			if (!this.room.id) return 0;
			return Math.max(
				parseInt(this.room.capacity_standing),
				parseInt(this.room.capacity_chairs),
				parseInt(this.room.capacity_tables),
				this.room.layouts.reduce(
					(max, l) => Math.max(max, parseInt(l.capacity)),
					0
				)
			);
		},
		selectedDate: {
			get() {
				return this.$store.state.selectedDate;
			},
			set(value) {
				this.$store
					.dispatch('fetchOpeningHoursForDate', value)
					.then(() => {
						this.$store.commit('selectedDate', value);
						this.updateDetails();
					});
			}
		},
		userClassId: {
			get() {
				return this.$store.state.userClassId;
			},
			set(value) {
				this.$store.commit('userClassId', value);
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.room-details {
	max-width: 1000px;
	.room-image {
		max-width: 620px;
	}
	.room-details-sidebar {
		max-width: 350px;
	}
}
.search-form-holder {
	position: relative;
	z-index: 2;
}
.logo-area {
	background-color: var(--header-color-2);
}
.basket-area {
	background-color: var(--header-color-1);
	color: var(--header-color-3);
}
</style>
